import { lazy, Suspense } from "react";
import { PATH_APP } from "./paths";
import HomePageSkeleton from "../pages/HomePage/ui/PageSkeleton";
import ActivityPageSkeleton from "../pages/ActivityPage/ui/PageSkeleton";
import HelpPageSkeleton from "../pages/HelpPage/ui/PageSkeleton";
import InstrumentPageSkeleton from "../pages/InstrumentPage/ui/PageSkeleton";
import MarketPageSkeleton from "../pages/MarketPage/ui/PageSkeleton";
import ProfilePageSkeleton from "../pages/ProfilePage/ui/PageSkeleton";
import ReportsPageSkeleton from "../pages/ReportsPage/ui/PageSkeleton";
import ReturnsPageSkeleton from "../pages/ReturnsPage/ui/PageSkeleton";
import TransactionPageSkeleton from "../pages/TransactionPage/ui/PageSkeleton";
import ValuationPageSkeleton from "../pages/ValuationPage/ui/PageSkeleton";
import YearReportsPageSkeleton from "../pages/ReportsPage/YearReportsPage/ui/PageSkeleton";
import ResearchPageSkeleton from "../pages/ResearchPage/ui/PageSkeleton";
import SearchInstrumentsMobilePageSkeleton from "../pages/SearchInstrumentsMobilePage/ui/PageSkeleton";

//PAGES COMPONENTS
const ActivityPage = lazy(() => import("../pages/ActivityPage/ActivityPage"));
const HelpPage = lazy(() => import("../pages/HelpPage/HelpPage"));
const HomePage = lazy(() => import("../pages/HomePage/HomePage"));
const InstrumentPage = lazy(
  () => import("../pages/InstrumentPage/InstrumentPage")
);
const MarketPage = lazy(() => import("../pages/MarketPage/MarketPage"));
const ProfilePage = lazy(() => import("../pages/ProfilePage/ProfilePage"));
const ReportsPage = lazy(() => import("../pages/ReportsPage/ReportsPage"));
const ReturnsPage = lazy(() => import("../pages/ReturnsPage/ReturnsPage"));
const TransactionPage = lazy(
  () => import("../pages/TransactionPage/TransactionPage")
);
const ValuationPage = lazy(
  () => import("../pages/ValuationPage/ValuationPage")
);
const YearReportsPage = lazy(
  () => import("../pages/ReportsPage/YearReportsPage/YearReportsPage")
);
const ResearchPage = lazy(() => import("../pages/ResearchPage/ResearchPage"));
const SearchInstrumentsMobilePage = lazy(() =>
  import("../pages/SearchInstrumentsMobilePage/SearchInstrumentsMobilePage").then(
    (m) => ({ default: m.SearchInstrumentsMobilePage })
  )
);

export const appRoutesList = [
  {
    key: "home",
    route: PATH_APP.home,
    element: (
      <Suspense fallback={<HomePageSkeleton />}>
        <HomePage />
      </Suspense>
    ),
    index: true,
  },
  {
    key: "valuation",
    route: PATH_APP.valuation,
    element: (
      <Suspense fallback={<ValuationPageSkeleton />}>
        <ValuationPage />
      </Suspense>
    ),
  },
  {
    key: "returns",
    route: PATH_APP.returns,
    element: (
      <Suspense fallback={<ReturnsPageSkeleton />}>
        <ReturnsPage />
      </Suspense>
    ),
  },
  {
    key: "reports",
    route: PATH_APP.reports,
    element: (
      <Suspense fallback={<ReportsPageSkeleton />}>
        <ReportsPage />
      </Suspense>
    ),
  },
  {
    key: "yearReports",
    route: `${PATH_APP.reports}/:year`,
    element: (
      <Suspense fallback={<YearReportsPageSkeleton />}>
        <YearReportsPage />
      </Suspense>
    ),
  },
  {
    key: "transactions",
    route: PATH_APP.transactions,
    element: (
      <Suspense fallback={<TransactionPageSkeleton />}>
        <TransactionPage />
      </Suspense>
    ),
  },
  {
    key: "activity",
    route: PATH_APP.activity,
    element: (
      <Suspense fallback={<ActivityPageSkeleton />}>
        <ActivityPage />
      </Suspense>
    ),
  },
  {
    key: "profile",
    route: PATH_APP.profile,
    element: (
      <Suspense fallback={<ProfilePageSkeleton />}>
        <ProfilePage />
      </Suspense>
    ),
  },
  {
    key: "help",
    route: PATH_APP.help,
    element: (
      <Suspense fallback={<HelpPageSkeleton />}>
        <HelpPage />
      </Suspense>
    ),
  },
  {
    key: "market",
    route: PATH_APP.market,
    element: (
      <Suspense fallback={<MarketPageSkeleton />}>
        <MarketPage />
      </Suspense>
    ),
  },
  {
    key: "research",
    route: PATH_APP.research,
    element: (
      <Suspense fallback={<ResearchPageSkeleton />}>
        <ResearchPage />
      </Suspense>
    ),
  },
  {
    key: "favorites",
    route: PATH_APP.favorites,
    element: (
      <Suspense fallback={<MarketPageSkeleton />}>
        <MarketPage />
      </Suspense>
    ),
  },
  {
    key: "isntrument",
    route: PATH_APP.instrument,
    element: (
      <Suspense fallback={<InstrumentPageSkeleton />}>
        <InstrumentPage />
      </Suspense>
    ),
  },
  {
    key: "searchInstruments",
    route: PATH_APP.searchInstruments,
    element: (
      <Suspense fallback={<SearchInstrumentsMobilePageSkeleton />}>
        <SearchInstrumentsMobilePage />
      </Suspense>
    ),
  },
  {
    key: "searchInstrumentsByType",
    route: `${PATH_APP.searchInstruments}/:instrumentType`,
    element: (
      <Suspense fallback={<SearchInstrumentsMobilePageSkeleton />}>
        <SearchInstrumentsMobilePage />
      </Suspense>
    ),
  },
  {
    key: "searchFavoritesByType",
    route: `${PATH_APP.searchFavorites}/:instrumentType`,
    element: (
      <Suspense fallback={<SearchInstrumentsMobilePageSkeleton />}>
        <SearchInstrumentsMobilePage />
      </Suspense>
    ),
  },
  {
    key: "searchFavorites",
    route: PATH_APP.searchFavorites,
    element: (
      <Suspense fallback={<SearchInstrumentsMobilePageSkeleton />}>
        <SearchInstrumentsMobilePage />
      </Suspense>
    ),
  },
];
